import type { FC } from 'react';

import Typography from '@/components/typography';

export const SelectionsPanelEmptyContent: FC = () => {
  return (
    <div className="flex h-full flex-col items-center p-6">
      <div className="flex w-full flex-col gap-2 text-gray-50">
        <Typography variant="button1">Selections</Typography>
        <Typography variant="body1">
          <span>
            Zoom in to select parcels or create custom points, lines, and shapes
            using the toolbar. Selecting will allow you to view insights, share
            your map, and generate reports.
          </span>
          <br />
          <br />
          <span>
            Save your map to easily return to your work anytime, including in
            the field with the Acres Mobile app.
          </span>
        </Typography>
      </div>
    </div>
  );
};
